import { NgModule } from '@angular/core';
import { SpinnersModule } from '@core/components/spinners/spinners.module';

/**
 * Общий модуль для спиннеров и индикаторов загрузки.
 * Этот модуль объединяет все спиннер компоненты и должен импортироваться
 * в модулях, которым нужны спиннеры.
 */
@NgModule({
  imports: [SpinnersModule],
  exports: [SpinnersModule],
})
export class SharedSpinnersModule {}
